import { Injectable } from '@angular/core';
import { I18nService } from './i18n.service';
import { NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap';

const I18N_VALUES = {
  en: {
    weekdays: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
    months: [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December'
    ]
  },
  es: {
    weekdays: ['Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa', 'Do'],
    months: [
      'Enero',
      'Febrero',
      'Marzo',
      'Abril',
      'Mayo',
      'Junio',
      'Julio',
      'Agosto',
      'Septiembre',
      'Octubre',
      'Noviembre',
      'Diciembre'
    ]
  }
};

@Injectable({
  providedIn: 'root'
})
export class CustomDatepickerI18nService extends NgbDatepickerI18n {
  constructor(private i18nService: I18nService) {
    super();
  }
  getWeekdayShortName(weekday: number): string {
    return I18N_VALUES[this.i18nService.currentLanguage].weekdays[weekday - 1];
  }
  getMonthShortName(month: number, year?: number): string {
    return I18N_VALUES[this.i18nService.currentLanguage].months[month - 1];
  }
  getMonthFullName(month: number, year?: number): string {
    return this.getMonthShortName(month);
  }
  getDayAriaLabel(
    date: import('@ng-bootstrap/ng-bootstrap').NgbDateStruct
  ): string {
    return `${date.day}/${date.month}/${date.year}`;
  }
}
